import { render, staticRenderFns } from "./list-summary.vue?vue&type=template&id=2617a9b9&"
import script from "./list-summary.vue?vue&type=script&lang=js&"
export * from "./list-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports